export default __webpack_public_path__ + "static/media/screen3@3x.6b8b7874.png";